import React from 'react';
import './ActiveProjects.css';
import wynn_Al from '../../../Gemco-Website-Images/Homepage/HP-02-Wynn_Al_Marjan_Island_RAK.jpg';
import one_Zaabeel from '../../../Gemco-Website-Images/Homepage/HP-03-One_Zaabeel_Dubai.webp';
import museum_of_the_future from '../../../Gemco-Website-Images/Homepage/HP-03-museum-of-the-future.webp';
import Matoum_International_Airport from '../../../Gemco-Website-Images/Homepage/HP_04-Matoum_International_Airport.webp';


const ActiveProjects = () => {

  return (
    <div>
      <div className="wp_activeproject">
        <h1>CURRENTLY ACTIVE PROJECTS</h1>
        <div className="container wp_pill_wrap col-md-12">
          <div className="wp_pill1">
            <div className="card wp_activeproject_card">
              <img className='pill-img' src={wynn_Al} alt="Wynn Al Marjan Island, RAK" />
              <div className="card-body">
                <div className="card-title text-ongoing">ONGOING</div>
                <div className="card-text">Wynn Al Marjan Island, RAK · MEP Supply & Installation</div>
              </div>
            </div>
          </div>
          <div className="wp_pill2">
            <div className="card wp_activeproject_card">
              <img className='pill-img' src={one_Zaabeel} alt="One Za'abeel, Dubai" />
              <div className="card-body">
                <div className="card-title text-ongoing">ONGOING</div>
                <div className="card-text">One Za'abeel, Dubai · MEP Retrofit Supply & Installation</div>
              </div>
            </div>
          </div>
          <div className="wp_pill3">
            <div className="card wp_activeproject_card">
              <img className='pill-img' src={museum_of_the_future} alt="museum of the future" />
              <div className="card-body">
                <div className="card-title text-ongoing">ONGOING</div>
                <div className="card-text">Museum of the Future · MEP Retrofit Works</div>
              </div>
            </div>
          </div>
          <div className="wp_pill4">
            <div className="card wp_activeproject_card">
              <img className='pill-img' src={Matoum_International_Airport} alt="Campus Legacy" />
              <div className="card-body">
                <div className="card-title text-ongoing">ONGOING</div>
                <div className="card-text">Al Maktoum Airport · Mechanical & Electrical Works</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActiveProjects